var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"footer small-text"},[_vm._v(" Business Transaction | Marktpreiseinschätzung | "),_c('b',[_vm._v(_vm._s(_vm.props.page))])])}
var staticRenderFns = []

export { render, staticRenderFns }